import type { FC } from 'react';
import type { TooltipRenderProps } from 'react-joyride';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';

import { StepContentStyled, TooltipWrapStyled } from './Tooltip.styled';

type TooltipPropsT = TooltipRenderProps;

const Tooltip: FC<TooltipPropsT> = ({
  index,
  isLastStep,
  step,
  backProps,
  primaryProps,
  tooltipProps,
  skipProps,
}) => (
  <TooltipWrapStyled {...tooltipProps}>
    <StepContentStyled variant="body1" align="center">
      {step.content}
    </StepContentStyled>

    <FlexContainer justify={isLastStep ? 'flex-end' : 'between'}>
      {!isLastStep && (
        <Button {...skipProps} variant="text">
          Skip
        </Button>
      )}
      <FlexContainer>
        <Button {...backProps} variant="text" disabled={!index}>
          Back
        </Button>
        <Button {...primaryProps} variant="contained">
          {isLastStep ? 'Complete' : 'Next'}
        </Button>
      </FlexContainer>
    </FlexContainer>
  </TooltipWrapStyled>
);

export default Tooltip;
